<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title"
        :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">

        <div class="container">
            <div id="div-modal-cxc" class="d-flex justify-content-center">
                <div id="div-cxc" class="card w-100">
                    <div class="card-header text-white h4 text-center" style="background: #900052">
                        <strong class="text-uppercase">Activos</strong>
                    </div>
                    <div class="card-body w-100">
                        <div class="row d-flex mx-0 px-0">
                            <div class="col-xl-12 mt-3 mb-4 table-responsive" id="content-timelinetable">
                                <table class="table text-xxs table-bordered border-main text-center align-middle"
                                    style="font-size: 12px;">
                                    <caption class="py-0 my-0"></caption>
                                    <thead>
                                        <tr class="text-white border-white text-center text-uppercase"
                                            style="background: #900052; vertical-align: middle">
                                            <th scope="col">N°</th>
                                            <th scope="col">Almacen</th>
                                            <th scope="col">Piso</th>
                                            <th scope="col">Area</th>
                                            <th scope="col">Lugar</th>
                                            <th scope="col">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="table-body text-center" v-if="cpData.length === 0">
                                            <td colspan="6" class="text-center">No hay registros</td>
                                        </tr>
                                        <tr v-for="(activo, index) in cpData" :key="activo.id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ almacenNames(activo.almacen_id) }}</td>
                                            <td>{{ pisoNames(activo.floor_id) }}</td>
                                            <td>{{ areaNames(activo.area_id) }}</td>
                                            <td>{{ getLugar(activo.lugar) }}</td>
                                            <td>
                                                <div class="text-center d-flex justify-content-center">
                                                    <button class="btn btn-sm a-success text-white"
                                                        @click="mtdModalShow(activo)">
                                                        <i class="fas fa-solid fa-truck"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Paginación -->
                            <div v-if="cpData.length > 0" class="d-flex justify-content-center mb-2">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination mb-1">
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)"
                                                @click="backPage">Anterior</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'"
                                                href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>

                                        <li v-for="(item, index) in limitedStepPagination" :key="index"
                                            class="page-item">
                                            <a :class="selectPage === item ? 'page-link active' : 'page-link'"
                                                href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                            </a>
                                        </li>
                                        <li v-if="limitedStepPagination[limitedStepPagination.length - 1] < stepPagination.length - 1"
                                            class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li v-if="limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length"
                                            class="page-item">
                                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active' : 'page-link'"
                                                href="javascript:void(0)"
                                                @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)"
                                                @click="nextPage">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </CModal>
</template>
<script>
import CModal from "@/components/shared/modals/CModal.vue";
import { mapActions } from "vuex";

export default {
    name: "c-movimientos-activos",
    components: {
        CModal,
    },
    data() {
        return {
            dataAlmacenes: [],
            dataPisos: [],
            dataAreas: [],
            dataActivos: [],
            //Paginacion
            dataShow: [],
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        payload: Array,
        id_activo: Number
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;
            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                length: endPage - startPage + 1,
            },
                (_, i) => startPage + i
            );
        },
        almacenNames() {
            return (almacenId) => {
                const almacen = this.dataAlmacenes.find(a => a.id === almacenId);
                return almacen ? almacen.name : 'No especificado';
            };
        },
        pisoNames() {
            return (pisoId) => {
                const piso = this.dataPisos.find(p => p.id === pisoId);
                return piso ? piso.name : 'No especificado';
            };
        },
        areaNames() {
            return (areaId) => {
                const area = this.dataAreas.find(a => a.id === areaId);
                return area ? area.name : 'No especificado';
            };
        },
    },

    watch: {
        boo_modal(newVal) {
            if (newVal == true) {
                this.mtdGetDataLogistic();
            }
        },
        payload: {
            handler(newVal) {
                if (newVal) {
                    this.mtdLlenarDatos(newVal)
                }
            },
            immediate: true,
        },
        selectPage() {
            this.calculateData(7);
        },
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdClose() {
            this.$emit("closeModalActivos");
        },
        mtdLlenarDatos(datos) {
            this.dataActivos = datos
            this.calculateData(7);
        },
        mtdGetDataLogistic() {
            this.get({
                url: this.$store.getters.get__url + "/logistics/byData",
                token: this.$store.getters.get__token,
            }).then((response) => {
                this.dataAlmacenes = response.data.almacenes;
                this.dataPisos = response.data.pisos;
                this.dataAreas = response.data.areas;
            })
        },
        getLugar(lugar) {
            if (lugar == null) {
                const nameLugar = 'No especificado';
                return nameLugar;
            } else {
                return lugar
            }
        },
        mtdModalShow: function (item) {
            this.$emit('mtd_modal', item, this.id_activo)
        },
        //Paginación
        calculateData(items) {
            if (!this.dataActivos || !this.dataActivos.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.dataActivos;
            let indexInitial = this.selectPage;
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                length: totalPages,
            },
                (_, index) => index + 1
            );
            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
            this.count = this.count + 1;
        },
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                    this.selectPage + 1 :
                    this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
    }
}
</script>